import React, { useState, useEffect } from "react";
import IngredientItem from "./IngredientItem";
import AddIngredientForm from "./AddIngredientForm";
import {Container, Row, Col, Form, Button, Alert} from "react-bootstrap";
import NotificationStack from "../NotificationStack";
import { v4 as uuidv4 } from "uuid";

const IngredientList = () => {
    const addToShoppingList = (item) => {
        const shoppingList = JSON.parse(localStorage.getItem("shoppingList")) || [];
        shoppingList.push(item);
        localStorage.setItem("shoppingList", JSON.stringify(shoppingList));
    };

    const [ingredients, setIngredients] = useState(() => {
        const storedIngredients = localStorage.getItem("ingredients");
        return storedIngredients ? JSON.parse(storedIngredients) : [];
    });

    const [search, setSearch] = useState("");
    const [sortBy, setSortBy] = useState("name");
    const [sortOrder, setSortOrder] = useState("asc");
    const [notifications, setNotifications] = useState([]);

    const addNotification = (message) => {
        setNotifications((prev) => [...prev, message]);
    };

    const removeNotification = () => {
        setNotifications((prev) => prev.slice(1));
    };
    useEffect(() => {
        localStorage.setItem("ingredients", JSON.stringify(ingredients));
    }, [ingredients]);


    const addIngredient = (ingredient) => {
        if (!ingredient.name.trim() || isNaN(parseFloat(ingredient.amount))) {
            console.error("⚠️ Chyba: Neplatná ingredience!");
            return;
        }

        const newIngredient = {
            id: ingredient.id || uuidv4(), // ✅ Vytvoří unikátní ID pokud chybí
            name: ingredient.name.trim(),
            amount: parseFloat(String(ingredient.amount).replace(",", ".")), // ✅ Oprava pro desetinnou čárku
            unit: ingredient.unit || "ks",
            expiration: ingredient.expiration || "",
            minAmount: parseFloat(String(ingredient.minAmount || 0).replace(",", ".")),
            isBasic: ingredient.isBasic || false,
            note: ingredient.note || ""
        };

        setIngredients((prev) => [...prev, newIngredient]);
    };

    const removeIngredient = (id) => {
        setIngredients((prev) => prev.filter(item => item.id !== id));
    };

    const updateIngredient = (id, updatedData) => {
        setIngredients((prev) =>
            prev.map((ingredient) =>
                ingredient.id === id ? { ...ingredient, ...updatedData } : ingredient
            )
        );
    };

    // 🔍 **Filtruje ingredience podle názvu**
    let filteredIngredients = ingredients.filter(ingredient =>
        ingredient.name.toLowerCase().includes(search.toLowerCase())
    );

    // 📌 **Řazení podle vybrané hodnoty**
    filteredIngredients.sort((a, b) => {
        if (sortBy === "name") {
            return sortOrder === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
        } else if (sortBy === "amount") {
            return sortOrder === "asc" ? a.amount - b.amount : b.amount - a.amount;
        } else if (sortBy === "expiration") {
            return sortOrder === "asc"
                ? new Date(a.expiration) - new Date(b.expiration)
                : new Date(b.expiration) - new Date(a.expiration);
        }
        return 0;
    });

    // 🔄 **Uspořádání ingrediencí (sloučení se stejným názvem, expirací a jednotkou)**
    const mergeIngredients = () => {
        const merged = ingredients.reduce((acc, curr) => {
            const key = `${curr.name.toLowerCase()}-${curr.expiration}-${curr.unit}`; // 🔥 Bereme v potaz také jednotku
            if (!acc[key]) {
                acc[key] = { ...curr };
            } else {
                acc[key].amount = parseFloat(acc[key].amount) + parseFloat(curr.amount);
            }
            return acc;
        }, {});

        setIngredients(Object.values(merged));
    };

    return (
        <Container>
            <NotificationStack notifications={notifications} removeNotification={removeNotification} />
            <h2 className="text-success">📋 Moje ingredience</h2>
            <AddIngredientForm addIngredient={addIngredient}/>
            <Row>
                <Col xs={12} md={3}>
                    <Form.Label>🔍 Hledat:</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="🔍 Hledat ingredienci..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="mb-3"
                    />
                </Col>
                <Col xs={12} md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>📌 Řadit podle:</Form.Label>
                        <Form.Select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                            <option value="name">Název</option>
                            <option value="amount">Množství</option>
                            <option value="expiration">Expirace</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>🔄 Pořadí:</Form.Label>
                        <Form.Select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
                            <option value="asc">Vzestupně</option>
                            <option value="desc">Sestupně</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>

            {filteredIngredients.length === 0 ? (
                <p className="text-muted">Žádné ingredience odpovídající hledání.</p>
            ) : (
                <Row>
                    {filteredIngredients.map((ingredient) => (
                        <Col xs={12} md={6} key={ingredient.id}>
                            <IngredientItem
                                ingredient={ingredient}
                                updateIngredient={updateIngredient}
                                removeIngredient={removeIngredient}
                                addToShoppingList={addToShoppingList}
                                addNotification={addNotification}
                            />
                        </Col>
                    ))}
                </Row>
            )}
            <div className="mt-3">
                <Button variant="success" className="w-100" onClick={mergeIngredients}>
                    <i class="bi bi-arrow-down-up"></i> Uspořádat položky
                </Button>
            </div>
            <div className="shopping-guide">
                <p>🛒 V úpravě můžeš nastavit položku jako "základní". V
                    případě jejího nedostatku ji můžeš rychle přidat do nákupního seznamu!</p>
            </div>
        </Container>
    );
};

export default IngredientList;
